module Meevo.Plugins.DrawerManager {
    "use strict";

    export class DrawerOpenedSection extends Meevo.Plugins.DrawerManager.DrawerManagerSectionBase {

        constructor(
            drawerManagerContext: Meevo.Plugins.DrawerManager.DrawerManagerContext,
            protected dataService: Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            personalHeader: boolean,
            personalFooter: boolean
        ) {
            super(DrawerManager.DrawerManagerSectionTypeEnum.DrawerOpened, drawerManagerContext, "drawerOpened", personalHeader, personalFooter);
        }

        reset() {
            super.reset();

            if (this.context && this.context.selectedDrawer && this.context.selectedDrawer.drawerSession && this.context.selectedDrawer.drawerSession.drawerSessionHistory) {
                for (let index = this.context.selectedDrawer.drawerSession.drawerSessionHistory.length - 1; index >= 0; index--) {
                    let item = this.context.selectedDrawer.drawerSession.drawerSessionHistory[index];
                    if (item.drawerState === Meevo.Model.DrawerStateEnum.Open) {
                        this.context.mostRecentHistoryForOpen = item;
                    }
                }
            }
        }

        getSectionName() {
            return this.context.selectedDrawer.displayName + " - Opened";
        }

        getCashTransactionsAmount() {
            let cashPayment = this.context.getCashTransactionPaymentItem();
            return cashPayment ? cashPayment.amount : 0;
        }

        getTotalTipsCollected() {
            return (this.context.selectedDrawer && this.context.selectedDrawer.drawerSession && this.context.selectedDrawer.drawerSession.summary) 
                ? this.context.selectedDrawer.drawerSession.summary.totalTip 
                : 0;
        }

        getTotalCashInDrawer() {
            // TODO: JS rounding errors

            return this.context.selectedDrawer.drawerSession.openCashAmount + this.getCashTransactionsAmount() + this.context.getPayInOutTotal(Model.PaymentCategoryEnum.Cash);
        }

        getLatestOpeningNote() {
            return this.context.getLastDrawerSessionNote(Model.DrawerStateEnum.Open);
        }

        getDrawerTotal() {
            // TODO: JS rounding errors
            let totalPayments = 0;

            if (this.context.selectedDrawer && this.context.selectedDrawer.drawerSession && this.context.selectedDrawer.drawerSession.aggregatedPaymentTransactions) {
                this.context.selectedDrawer.drawerSession.aggregatedPaymentTransactions.forEach((pt) => { totalPayments += pt.amount });
            }

            return this.context.selectedDrawer.drawerSession.openCashAmount + this.context.getPayInOutTotal(Model.PaymentCategoryEnum.Cash) + totalPayments;
        }

        refresh() {
            this.context.getDrawerSession(this.context.selectedDrawer.id, true, this.context.selectedDrawer.drawerSession.id, true);
        }
    }
}